class CountdownTimer extends HTMLElement {
  constructor() {
    super();
    this.interval = null;
  }

  connectedCallback() {
    this.initializeElements();
    this.startCountdown();
  }

  disconnectedCallback() {
    this.stopCountdown();
  }

  static get observedAttributes() {
    return ['data-end-date'];
  }

  attributeChangedCallback(name, oldValue, newValue) {
    if (name === 'data-end-date' && oldValue !== newValue) {
      this.stopCountdown();
      this.startCountdown();
    }
  }

  initializeElements() {
    this.daysEl = this.querySelector('[data-time-unit="days"]');
    this.hoursEl = this.querySelector('[data-time-unit="hours"]');
    this.minutesEl = this.querySelector('[data-time-unit="minutes"]');
    this.secondsEl = this.querySelector('[data-time-unit="seconds"]');
  }

  startCountdown() {
    this.stopCountdown();

    const endDateStr = this.dataset.endDate;
    this.endDate = new Date(endDateStr);

    if (!endDateStr || isNaN(this.endDate.getTime())) {
      console.warn(`CountdownTimerElement (${this.id || 'unknown'}): Invalid or missing end date`);
      this.setValues('00', '00', '00', '00');
      return;
    }

    this.updateCountdown();
    this.interval = setInterval(() => this.updateCountdown(), 1000);
  }

  stopCountdown() {
    if (this.interval) {
      clearInterval(this.interval);
      this.interval = null;
    }
  }

  updateCountdown() {
    const now = new Date();
    const diff = this.endDate - now;

    if (diff <= 0) {
      this.setValues('00', '00', '00', '00');
      this.stopCountdown();
      return;
    }

    const days = Math.floor(diff / (1000 * 60 * 60 * 24));
    const hours = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((diff % (1000 * 60)) / 1000);

    this.setValues(this.formatTime(days), this.formatTime(hours), this.formatTime(minutes), this.formatTime(seconds));
  }

  setValues(days, hours, minutes, seconds) {
    if (this.daysEl) this.daysEl.textContent = days;
    if (this.hoursEl) this.hoursEl.textContent = hours;
    if (this.minutesEl) this.minutesEl.textContent = minutes;
    if (this.secondsEl) this.secondsEl.textContent = seconds;
  }

  formatTime(value) {
    return value < 10 ? '0' + value : String(value);
  }
}

if (!customElements.get('countdown-timer')) {
  customElements.define('countdown-timer', CountdownTimer);
}
